/* eslint-disable */
import { Observable, Observer } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { Order, OrderType, } from '../../util/services';
import { MemStorage } from '../../util/mem-storage';
import { Injectable } from '@angular/core';
import {MultiselectOptionItem, UiConstants} from '../../../util/core-utils';
import { TaskStatistics } from './task-statistics.service';
import { RuntimeConfiguration } from '../../runtime-configuration';
import { LoggedInUserStorage } from '../../util/storages';
import {NgbDateStruct, NgbTimeStruct} from "@ng-bootstrap/ng-bootstrap";
import {TaskMultiselectOptionItem} from "../../task/task-multiselect.provider";
/* eslint-enable */

@Injectable()
export class TaskStatisticsSearchService {

  constructor() {
  }

  getSearchData(request: TaskStatisticsSearch.SearchDataGetRequest): Observable<TaskStatisticsSearch.SearchDataResult> {
    const storage = this.createStorage();
    return Observable.create((observer: Observer<TaskStatisticsSearch.SearchDataResult>) => {
      try {
        observer.next(storage.read(request));
      }
      catch (e) {
        observer.error(e);
      }
      observer.complete();
      return function () {
      };
    });
  }

  setSearchData(request: TaskStatisticsSearch.SearchDataSetRequest): Observable<TaskStatisticsSearch.SearchDataResult> {
    const storage = this.createStorage();
    return Observable.create((observer: Observer<TaskStatisticsSearch.SearchDataResult>) => {
      try {
        observer.next(storage.save(request));
      }
      catch (e) {
        observer.error(e);
      }
      observer.complete();
      return function () {
      };
    });
  }

  resetSearchData(request: TaskStatisticsSearch.SearchDataGetRequest): Observable<TaskStatisticsSearch.SearchDataResult> {
    const storage = this.createStorage();
    return Observable.create((observer: Observer<TaskStatisticsSearch.SearchDataResult>) => {
      try {
        observer.next(storage.reset(request));
      }
      catch (e) {
        observer.error(e);
      }
      observer.complete();
      return function () {
      };
    });
  }

  private createStorage(): TaskStatisticsSearch.Storage {
    return new TaskStatisticsSearch.Storage();
  }

}

export namespace TaskStatisticsSearch {

  export interface SearchDataGetRequest {
  }

  export interface SearchDataSetRequest {
    searchData: SearchData;
  }

  export interface SearchDataResult {
    searchData: SearchData;
  }

  export interface SearchData {
    itemsPerPage: number;
    pageNumber: number;
    order: Order<TaskStatistics.OrderField>;
    task: TaskMultiselectOptionItem[];
    user: MultiselectOptionItem<number>[];
    fromDate: NgbDateStruct | null;
    toDate: NgbDateStruct | null;
    fromTime: NgbTimeStruct | null;
    toTime: NgbTimeStruct | null;
  }

  interface StoredSearchRawDataBase {
    version: number;
  }

  interface StoredSearchRawData extends StoredSearchRawDataBase {
    itemsPerPage: number;
    pageNumber: number;
    order: Order<TaskStatistics.OrderField>;
    task: TaskMultiselectOptionItem[];
    user: MultiselectOptionItem<number>[];
    fromDate: NgbDateStruct | null;
    toDate: NgbDateStruct | null;
    fromTime: NgbTimeStruct | null;
    toTime: NgbTimeStruct | null;
  }

  export class Storage {

    /**
     * Increment this version if you change the SearchData interface.
     */
    private static readonly VERSION: number = 3;

    private static readonly DEFAULT_SEARCH_DATA: SearchData = {
      itemsPerPage: UiConstants.pageNumbers[0],
      pageNumber: 1,
      order: {
        field: TaskStatistics.OrderField.TASK_ID,
        type: OrderType.DESC
      },
      task: [],
      user: [],
      fromDate: null,
      toDate: null,
      fromTime: null,
      toTime: null,
    };

    constructor() {
    }

    public read(request: SearchDataGetRequest): SearchDataResult {
      let rawBase: StoredSearchRawDataBase;
      try {
        const key = this.generateKey();
        const json = MemStorage.getItem(key);
        if (!json) {
          return this.createDefaultResult();
        }
        rawBase = JSON.parse(json);
      }
      catch (error) {
        return this.createDefaultResult();
      }
      if (Storage.VERSION === rawBase.version) {
        const raw: StoredSearchRawData = <StoredSearchRawData> rawBase;
        return this.fromRaw(raw);
      }
      return this.createDefaultResult();
    }

    public reset(request: SearchDataGetRequest): SearchDataResult {
      return this.save({
        searchData: Storage.DEFAULT_SEARCH_DATA,
      });
    }

    public save(request: SearchDataSetRequest): SearchDataResult {
      const key = this.generateKey();
      const raw = this.toRaw(request.searchData);
      const json = JSON.stringify(raw);
      MemStorage.setItem(key, json);
      return this.read(request);
    }

    private generateKey(): string {
      return 'UserId(' + LoggedInUserStorage.getInstance().getUserId() + ')-Search-Task-Statistics';
    }

    private createDefaultResult(): SearchDataResult {
      return {
        searchData: Storage.DEFAULT_SEARCH_DATA,
      };
    }

    private fromRaw(data: StoredSearchRawData): SearchDataResult {
      return {
        searchData: {
          itemsPerPage: data.itemsPerPage,
          pageNumber: data.pageNumber,
          order: data.order,
          task: data.task,
          user: data.user,
          fromDate: data.fromDate,
          toDate: data.toDate,
          fromTime: data.fromTime,
          toTime: data.toTime,
        }
      };
    }

    private toRaw(data: SearchData): StoredSearchRawData {
      return {
        version: Storage.VERSION,
        itemsPerPage: data.itemsPerPage,
        pageNumber: data.pageNumber,
        order: data.order,
        task: data.task,
        user: data.user,
        fromDate: data.fromDate,
        toDate: data.toDate,
        fromTime: data.fromTime,
        toTime: data.toTime,
      };
    }

  }

}
